module.exports = __webpack_public_path__ + "img/vrbee.8be8fb4c.jpg";